var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.742,
    height: 14.987,
    viewBox: "0 0 11.742 14.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14292",
    "data-name": "Group 14292",
    transform: "translate(-4204.532 -3928.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14291",
    "data-name": "Group 14291",
    transform: "translate(4213.593 3928.101) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11112",
    "data-name": "Path 11112",
    d: "M0,0H12.759",
    transform: "translate(0 3.217)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11113",
    "data-name": "Path 11113",
    d: "M0,0,3.216,3.216,0,6.433",
    transform: "translate(9.542)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11258",
    "data-name": "Path 11258",
    d: "M4213.057,3940h2.717v8.108h-10.742V3940h2.686",
    transform: "translate(0 -5.52)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b301132c870026acb4d15d770e9e296e.svg";
export { ForwardRef as ReactComponent };